"use client";

import { useEffect, useRef } from "react";
import { subscribeForeground } from "@/lib/app-lifecycle";

/**
 * Runs `callback` whenever the app returns to the foreground — a native resume
 * (`@capacitor/app` `appStateChange` → `isActive`) or the web tab becoming
 * visible again. The latest `callback` is always invoked, so it's safe to pass
 * an inline closure without memoizing it.
 */
export function useAppForeground(callback: () => void): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    return subscribeForeground(() => {
      callbackRef.current();
    });
  }, []);
}
